import { render, staticRenderFns } from "./CardChanges.vue?vue&type=template&id=2956020d&scoped=true"
import script from "./CardChanges.vue?vue&type=script&lang=js"
export * from "./CardChanges.vue?vue&type=script&lang=js"
import style0 from "./CardChanges.vue?vue&type=style&index=0&id=2956020d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2956020d",
  null
  
)

export default component.exports